// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__bSC8j","menuItem":"styles_menuItem__MfU4d","topFeedback":"styles_topFeedback__ALc5U","openMobile":"styles_openMobile__-Klj1"};